// Port of api/fuel/app/classes/model/log/user/edition.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'

export default Model.extend({
	table: 'log_user_edition',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		group_id: Model.SCHEMA_NUMBER,
		buddies_id: Model.SCHEMA_NUMBER,
		list_id: Model.SCHEMA_NUMBER,
		list_edition_id: Model.SCHEMA_NUMBER,
		log_context: Model.SCHEMA_NUMBER,
		log_list_name: Model.SCHEMA_TEXT,
		log_initial_sync: Model.SCHEMA_NUMBER
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_EDITION },
		to_array: function() {
			return {
				id: +this.get_id(),
				date: +this.get_date(),
				type: +this.get_type(),
				context: +this.get_context(),
				user: +this.get_user_id(),
				group: +this.get_group_id(),
				list: +this.get_list_id(),
				edition: +this.get_list_edition_id(),
				name: this.get_list_name()
			}
		}
	}
})
